export const cmps = {
    CODIGO: 'codigo',
    DENOMINACION: 'denominacion',
    ESTADO: 'estado'
}